// extracted by mini-css-extract-plugin
export default {"container":"MdtFeedbackTypeformComponent_container__rAXyS","qa":"MdtFeedbackTypeformComponent_qa__AwHKb","answer":"MdtFeedbackTypeformComponent_answer__krL2F"};